// Generated by Melange

import * as Buhta_cabinet__DocumentEdo from "../../grpc/DocumentEdo.js";
import * as Buhta_cabinet__SignFlowDesktop from "./SignFlowDesktop.js";
import * as Buhta_cabinet__SignFlowDesktopMulti2 from "./SignFlowDesktopMulti2.js";
import * as Buhta_cabinet__SignFlowMobile from "./SignFlowMobile.js";
import * as Buhta_cabinet__SignFlowMobileMulti from "./SignFlowMobileMulti.js";
import * as Buhta_core__GlobalStateContext from "../../../../../packages/core/lib/GlobalStateContext.js";
import * as Curry from "melange.js/curry.js";
import * as $$Promise from "../../../../../vendored/promise/promise.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function SignFlowPage(Props) {
  let code = Props.code;
  const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
  const deviceType = state.deviceType;
  const match = React.useState(function () {
    return false;
  });
  const setIsClient = match[1];
  const match$1 = React.useState(function () {
    
  });
  const setSignData = match$1[1];
  const signData = match$1[0];
  React.useEffect((function () {
    const __x = Buhta_cabinet__DocumentEdo.PublicSignService.view(undefined, code, undefined);
    $$Promise.map(__x, (function (result) {
      if (result.TAG !== /* Ok */ 0) {
        return;
      }
      const data = result._0;
      Curry._1(setSignData, (function (param) {
        return data;
      }));
    }));
  }), [code]);
  React.useEffect((function () {
    Curry._1(setIsClient, (function (param) {
      return true;
    }));
  }), []);
  if (signData === undefined) {
    return null;
  }
  const match$2 = signData.intent;
  if (!match[0]) {
    return null;
  }
  if (deviceType === "mobile" && typeof match$2 !== "string") {
    const variant = match$2.NAME;
    if (variant === "Single") {
      return JsxRuntime.jsx(Buhta_cabinet__SignFlowMobile.make, {
        code: code,
        doc: match$2.VAL
      });
    }
    if (variant === "Bulk") {
      return JsxRuntime.jsx(Buhta_cabinet__SignFlowMobileMulti.make, {
        data: match$2.VAL,
        code: code
      });
    }
    
  }
  if (typeof match$2 === "string") {
    return null;
  }
  const variant$1 = match$2.NAME;
  if (variant$1 === "Single") {
    return JsxRuntime.jsx(Buhta_cabinet__SignFlowDesktop.make, {
      code: code,
      doc: match$2.VAL
    });
  } else if (variant$1 === "Bulk") {
    return JsxRuntime.jsx(Buhta_cabinet__SignFlowDesktopMulti2.make, {
      code: code,
      data: match$2.VAL
    });
  } else {
    return null;
  }
}

const make = SignFlowPage;

export {
  make,
}
/* Buhta_cabinet__DocumentEdo Not a pure module */
